import { EChartsOption } from 'echarts';
import { Observable } from 'rxjs';
import { DetailsChartGaugeColor } from '@pt/pt-models';

export type AppSummaryRowStatus =
  | 'ADDED'
  | 'CHANGED'
  | 'REMOVED'
  | 'EQUAL'
  | 'ND';
export enum AppSummaryConfiguration {
  CASO_01 = '<b>CASO 01</b>: <br>widgetValue.appAssessmentUnsupported && app.appAssessmentUnsupported && !app.treatmentSelected',
  CASO_02 = '<b>CASO 02</b>: <br>widgetValue.appAssessmentUnsupported && app.appAssessmentUnsupported && app.treatmentSelected',
  CASO_03 = '<b>CASO 03</b>: <br>Entrambi !widgetValue.appAssessmentUnsupported e !app.appAssessmentUnsupported e hanno differenze',
  CASO_04 = '<b>CASO 04</b>: <br>REMOVE<br>Entrambi !widgetValue.appAssessmentUnsupported e !app.appAssessmentUnsupported e hanno differenze ma <b>treatmentSelected = false</b>',
  CASO_05 = '<b>CASO 05</b>: <br>Entrambi !widgetValue.appAssessmentUnsupported e !app.appAssessmentUnsupported e non hanno differenze',
  CASO_06 = '<b>CASO 06</b>: <br>REMOVE<br>Entrambi !widgetValue.appAssessmentUnsupported e !app.appAssessmentUnsupported e non hanno differenze ma <b>treatmentSelected = false</b>',
  CASO_07 = '<b>CASO 07</b>: <br>widgetValue.appAssessmentUnsupported && !app.appAssessmentUnsupported',
  CASO_08 = '<b>CASO 08</b>: <br>REMOVE<br>widgetValue.appAssessmentUnsupported && !app.appAssessmentUnsupported ma <b>treatmentSelected = false</b>',
  CASO_09 = '<b>CASO 09</b>: <br>!widgetValue.appAssessmentUnsupported && app.appAssessmentUnsupported',
  CASO_10 = '<b>CASO 10</b>: <br>REMOVE<br>!widgetValue.appAssessmentUnsupported && app.appAssessmentUnsupported ma <b>treatmentSelected = false</b>',
  CASO_11 = "<b>CASO 11</b>: <br>widgetValue non ha valore ma l'app è selezionata nel trattamento",
}

export interface AppSummaryRow {
  status: AppSummaryRowStatus;
  appId: number;
  appUUID: string;
  appName: string;
  requiredAlign: boolean;
  missingRIDValues: boolean;
  appAssessmentUnsupported: boolean;
  actualQueryValue: AppSummaryRowChart[];
  widgetValue: AppSummaryRowChart[];
}

export interface AppSummaryRowV2 {
  configuration: AppSummaryConfiguration;
  status: AppSummaryRowStatus;
  appId: number;
  appUUID: string;
  appName: string;

  warningMessage?: Observable<string>;

  widgetRidValue?: AppSummaryRowChart[];
  widgetMessage?: Observable<string>;

  showAlignBtn: boolean;
  showRemoveBtn: boolean;

  appRidValue?: AppSummaryRowChart[];
  appMessage?: Observable<string>;
}

export interface AppSummaryRowChart {
  label: Observable<string>;
  description: Observable<string>;
  value: number;
  options: EChartsOption;
}

export const RID_GAUGE_PALETTE: DetailsChartGaugeColor[] = [
  {
    maxValue: 0,
    color: '#aa0000',
  },
  {
    maxValue: 20,
    color: '#f87001',
  },
  {
    maxValue: 40,
    color: '#ffc107',
  },
  {
    maxValue: 60,
    color: '#bfd100',
  },
  {
    maxValue: 80,
    color: '#00aa00',
  },
  {
    maxValue: 100,
    color: '#009863',
  },
];
